module.exports = __webpack_public_path__ + "img/bg_function01_3_m.fa9b912f.png";